import { styled } from '@mui/material'
import { preventForwardProps } from 'utils/styledUtils'
import { IShareSocialButtons } from './types'

export const ShareSocialButtonsContainer = styled(
  'div',
  preventForwardProps(['cardComponent']),
)<IShareSocialButtons>(({ theme, cardComponent }) => ({
  display: 'flex',
  gap: cardComponent ? theme.spacing(1) : theme.spacing(1.5),
  alignItems: 'center',
  flexDirection: cardComponent ? 'row' : 'column-reverse',
}))

export const ButtonsContainer = styled(
  'div',
  preventForwardProps(['cardComponent']),
)<IShareSocialButtons>(({ theme, cardComponent }) => ({
  display: 'flex',
  gap: cardComponent ? theme.spacing(2) : theme.spacing(3),
  alignItems: 'center',
}))

export const Divider = styled('div')(({ theme }) => ({
  width: '16px',
  height: '1px',
  background: theme.palette.surface[200],
}))
